var _SpriteSymbol = require("/runner/_work/CertifyApp/CertifyApp/node_modules/rspack-plugin-svg-sprite/dist/runtime/symbol");
var SpriteSymbol = _SpriteSymbol.default || _SpriteSymbol;
var symbol = new SpriteSymbol({"id":"add-black","viewBox":"0 0 24 24","content":"<symbol id=\"add-black\" viewBox=\"0 0 24 24\" fill=\"black\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z\"/></symbol>"});
symbol.url = "/Scripts/dist/sprite.svg#add-black";
export default symbol;
